import {
    Avatar,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid2,
    MenuItem,
    Select
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Pagination from "@mui/material/Pagination";
import { styled, useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useMediaQuery from "@mui/material/useMediaQuery";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import usercalls from "../../Axios";
import consts from "../../constant";
import Header from "../Header/Header";
import "./TradePair.css";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const drawerWidth = 260;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(2),
        justifyContent: "center",
    },
}));

const P2pList = () => {
    const [result, setResult] = useState([]);
    const Navigate = useNavigate();
    const tabelHeader = [
        "S.no",
        "Coin",
        "Icon",
        "Action",
    ];

    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const path = usercalls();
    const [data, setData] = useState([]);
    const [assets, setAssets] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [conModal, setconModal] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");
    const [selectedAss, setSelectedAss] = useState("");

    const token = localStorage.getItem("adminToken");

    const getPairs = async () => {
        const url = `${consts?.BackendUrl}/p2p/getp2passets`;

        Axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                setData(response?.data?.result);
                setTotalPage(Math.ceil(response?.data?.result?.length / limit));
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };

    const getAss = async () => {
        const url = `${consts?.BackendUrl}/admin/getassets`;

        Axios.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                setAssets(response?.data?.result);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };

    useEffect(() => {
        if (localStorage.getItem("adminToken")) {
            getPairs();
            getAss();
        } else {
            Navigate(`/${consts.route + "/login"}`);
        }
    }, []);


    const createP2pAsset = async () => {
        try {
            const url = `${consts?.BackendUrl}/admin/createp2passet`;
            const token = localStorage.getItem("adminToken");

            const assetData = {
                symbol: selectedValue
            };

            const response = await Axios.post(url, assetData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (response?.data?.success) {
                toast.success(response?.data?.message)
                getPairs();
                setOpenModal(false);
            } else {
                toast.error(response?.data?.message)
            }

            console.log("Asset created successfully:", response.data);
        } catch (error) {
            console.error("Error creating asset:", error);
        }
    };
    
    const deleteAsset = async () => {
        try {
            const url = `${consts?.BackendUrl}/admin/deletep2pass`;
            const token = localStorage.getItem("adminToken");

            const assetData = {
                assID: selectedAss
            };

            const response = await Axios.post(url, assetData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (response?.data?.success) {
                toast.success(response?.data?.message)
                getPairs();
                setconModal(false);
            } else {
                toast.error(response?.data?.message)
            }

            console.log("Asset created successfully:", response.data);
        } catch (error) {
            console.error("Error creating asset:", error);
        }
    };

    return (
        <div className="Asset">
            <ToastContainer />
            <Box sx={{ display: lg ? "flex" : "block" }}>
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 5,
                        width: { lg: `calc(100% - ${drawerWidth}px)` },
                        marginTop: "50px",
                    }}
                >
                    <h2 style={{ color:"#fff", margin:"0px" }}>P2P List</h2>
                    <Grid2 container spacing={2}>
                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        marginLeft: "auto",
                                        display: "block",
                                        marginTop: "20px",
                                    }}
                                    onClick={() => setOpenModal(true)}
                                >
                                    Create
                                </Button>
                            </Grid2>

                            <div className="custom_table">
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {tabelHeader.map((val, index) => {
                                                    return <TableCell align="center"> {val}</TableCell>;
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {[...data]
                                                .slice((page - 1) * limit, page * limit)
                                                ?.map((value, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            "&:last-child td, &:last-child th": { border: 0 },
                                                        }}
                                                    >
                                                        <TableCell align="center">
                                                            {limit * (page - 1) + index + 1}
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {value?.symbol}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {
                                                                value?.imageUrl ? (<img
                                                                    style={{ width: "30px", height: "30px" }}
                                                                    src={value?.imageUrl}
                                                                    alt={value?.symbol}
                                                                />) :
                                                                    (<Avatar sx={{ width: 25, height: 25 }}>
                                                                        {value?.symbol?.charAt(0)}
                                                                    </Avatar>)
                                                            }
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            <Button
                                                                sx={{
                                                                    marginLeft: "10px",
                                                                    backgroundColor: "none",
                                                                    color: "#fff",
                                                                    "&:hover": { backgroundColor: "#1565c0" },
                                                                    padding: "8px 16px",
                                                                    borderRadius: "8px",
                                                                    fontWeight: "bold",
                                                                }}
                                                                className="delete-btn"
                                                                variant="contained"
                                                                onClick={() => { setconModal(true); setSelectedAss(value?._id) }}
                                                            >
                                                                <DeleteForeverIcon/>
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className="pagnation"
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    // color='primary'
                                    shape="rounded"
                                />
                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>


            {/*Create Pair Model */}
            <BootstrapDialog open={openModal} onClose={() => setOpenModal(false)}>
                <div style={{ backgroundColor: "#10212c", width: "400px" }}>
                    <DialogTitle style={{ color: "white", }}>Select an Option</DialogTitle>
                    <DialogContent>
                        <Select
                            style={{ color: "white", border: '1px solid' }}
                            fullWidth
                            value={selectedValue}
                            onChange={(e) => setSelectedValue(e.target.value)}
                        >
                            {assets.length > 0 ? (
                                assets?.map((row, i) => (
                                    <MenuItem key={i} value={row?.coin_name}>{row?.coin_name}</MenuItem>
                                ))
                            ) : (
                                <MenuItem >No Data Found</MenuItem>
                            )}

                        </Select>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", gap: "30px" }}>
                        <Button variant="contained" sx={{
                            backgroundColor: "red",
                            color: "white",
                            "&:hover": { backgroundColor: "darkred" },
                        }} onClick={() => setOpenModal(false)}>Cancel</Button>
                        <Button variant="contained" onClick={() => createP2pAsset()} >Confirm</Button>
                    </DialogActions>
                </div>
            </BootstrapDialog>
            
            {/*Delete Confirmation Model */}
            <BootstrapDialog open={conModal} onClose={() => setconModal(false)}>
                <div style={{ backgroundColor: "#10212c", width: "300px" }}>
                    <DialogTitle style={{ color: "white" }}>Are You Sure You Want To Delete</DialogTitle>
                 
                    <DialogActions style={{ display: "flex", gap: "30px" }}>
                        <Button variant="contained" sx={{
                            backgroundColor: "red",
                            color: "white",
                            "&:hover": { backgroundColor: "darkred" },
                        }} onClick={() => setconModal(false)}>Cancel</Button>
                        <Button variant="contained" onClick={deleteAsset} >Confirm</Button>
                    </DialogActions>
                </div>
            </BootstrapDialog>
        </div>
    );
};

export default P2pList;
